import { useContext } from 'react';

// auth provider
import { AppAuthGlobalVariables } from '../contexts/AppAuthContext';

// ==============================|| AUTH HOOKS ||============================== //

const useAppContext = () => {
    const context:any = useContext(AppAuthGlobalVariables);
    //if (!context) throw new Error('context must be use inside provider');

    return context;
};

export default useAppContext;
